import { PATHWAY } from "@/constants/testIds";
import {
  FOOTER_DISCLAIMER,
  HIERARCHY,
  KATLAS_DEFINITION,
} from "@/lib/pathwayData";

export default function Footer() {
  return (
    <footer
      data-testid={PATHWAY.footer}
      className="border-t hairline bg-[#0a0a0a]"
    >
      <div className="mx-auto max-w-7xl px-6 py-16 md:px-12 md:py-20">
        <div className="grid gap-12 md:grid-cols-[1.3fr_1fr] md:gap-20">
          <div data-testid={PATHWAY.architectureDiagram}>
            <div className="font-mono text-[10px] uppercase tracking-[0.32em] text-neutral-500">
              Platform architecture
            </div>
            <div className="mt-5 border hairline bg-[#0f0f0f] p-5 font-mono text-[12px] leading-relaxed text-neutral-300">
              {HIERARCHY.map((h, i) => (
                <div
                  key={h.label}
                  className="grid grid-cols-[24px_1fr] gap-2"
                  style={{ paddingLeft: `${i * 14}px` }}
                >
                  <span className="text-neutral-600">
                    {i === 0 ? " " : "└─"}
                  </span>
                  <div>
                    <div
                      className={
                        h.current
                          ? "text-amber-500"
                          : "text-neutral-100"
                      }
                    >
                      {h.label}
                    </div>
                    <div className="text-neutral-500">{h.descriptor}</div>
                  </div>
                </div>
              ))}
            </div>
            <p className="mt-5 text-[12px] leading-relaxed text-neutral-500">
              Insurance is the first journey module on top of one reusable
              runtime. Freight, health, cities and manufacturing sit on the
              same governance engine.
            </p>
          </div>

          <div>
            <div className="font-mono text-[10px] uppercase tracking-[0.32em] text-neutral-500">
              KATLAS
            </div>
            <p className="mt-5 font-serif text-xl italic leading-snug text-neutral-200">
              “{KATLAS_DEFINITION}”
            </p>
            <p className="mt-8 text-[13px] leading-relaxed text-neutral-500">
              {FOOTER_DISCLAIMER}
            </p>
          </div>
        </div>

        <div className="mt-14 flex flex-col gap-3 border-t hairline pt-6 sm:flex-row sm:items-center sm:justify-between">
          <div className="font-mono text-[10px] uppercase tracking-[0.22em] text-neutral-500">
            Emerging Risk Lab Pathway · Insurance mode · {new Date().getFullYear()}
          </div>
          <div className="font-mono text-[10px] uppercase tracking-[0.22em] text-neutral-500">
            KATLAS runtime · Cierge Labs studio
          </div>
        </div>
      </div>
    </footer>
  );
}
